import React from "react";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";
import PropTypes from "prop-types";

function Dropdown({ label, value, options, onChange, width, size = "small" }) {
  return (
    <ArgonBox display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
      {/* Label */}
      {label && (
        <ArgonTypography variant="body2" fontWeight="medium">
          {label}
        </ArgonTypography>
      )}

      <select
        value={value}
        onChange={onChange}
        style={{
          marginLeft: label ? 8 : 0,
          width: width || 350,
          minHeight: size === "small" ? "39px" : "40px",
          padding: "6px 12px",
          borderRadius: "8px",
          border: "1px solid #ccc",
          cursor: "pointer",
          backgroundColor: "#fff",
          outline: "none",
          color: "#7b7a7aff",
          fontWeight: "500",
          fontSize: "14px",
          transition: "all 0.2s ease-in-out",
        }}
      >
        {options.map((option, idx) => {
          // agar string hai to string hi use hoga
          if (typeof option === "string") {
            return (
              <option key={idx} value={option}>
                {option}
              </option>
            );
          }

          // agar object hai to label/value use karo
          return (
            <option
              key={idx}
              value={option.value}
              disabled={option.disabled}
              style={{
                opacity: option.disabled ? 0.5 : 1,
                color: option.disabled ? "#bdbdbd" : "#344767",
                cursor: option.disabled ? "not-allowed" : "pointer",
              }}
            >
              {option.label}
            </option>
          );
        })}
      </select>
    </ArgonBox>
  );
}

// ✅ PropTypes flexible banaya
Dropdown.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  options: PropTypes.arrayOf(
    PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        label: PropTypes.string.isRequired,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        disabled: PropTypes.bool,
      }),
    ])
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOf(["small", "medium"]),
};

export default Dropdown;

// import React from "react";
// import ArgonBox from "components/ArgonBox";
// import ArgonTypography from "components/ArgonTypography";
// import PropTypes from "prop-types";

// function Dropdown({ label, value, options, onChange, width, size = "small" }) {
//   return (
//     <ArgonBox display="flex" alignItems="center" sx={{ cursor: "pointer" }}>
//       {/* Label */}
//       {label && (
//         <ArgonTypography variant="body2" fontWeight="medium">
//           {label}
//         </ArgonTypography>
//       )}

//       <select
//   value={value}
//   onChange={onChange}
//   style={{
//     marginLeft: label ? 8 : 0,
//     width: width || 350,
//     minHeight: size === "small" ? "39px" : "40px",
//     padding: "6px 12px",
//     borderRadius: "8px",
//     border: "1px solid #ccc",
//     cursor: "pointer",
//     backgroundColor: "#fff",
//     outline: "none",
//     color: "#7b7a7aff",
//     fontWeight: "500",
//     fontSize: "14px",
//     transition: "all 0.2s ease-in-out", // ✅ smooth transitions
//   }}
// >
//   <option value="" style={{ backgroundColor: "white" }}>Select</option>
//   {options.map((option, idx) => (
//     <option key={idx} value={option}  style={{
//         backgroundColor: "white !important", // ✅ force bg white
//         color: "#444 !important", // ✅ force text color
//       }}>
//       {option}
//     </option>
//   ))}
// </select>

//     </ArgonBox>
//   );
// }

// // ✅ PropTypes validation
// Dropdown.propTypes = {
//   label: PropTypes.string,
//   value: PropTypes.string.isRequired,
//   options: PropTypes.arrayOf(PropTypes.string).isRequired,
//   onChange: PropTypes.func.isRequired,
//   width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
//   size: PropTypes.oneOf(["small", "medium"]),
// };

// export default Dropdown;
